var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.198 2.9972C19.5435 2.58 18.7371 2.5359 18.0427 2.8803L16.216 3.7847C15.9376 1.782 14.2477 0.235001 12.2045 0.235001H4.81248C2.57604 0.235001 0.756226 2.0872 0.756226 4.365V10.0357C0.756226 12.3128 2.57535 14.1657 4.81248 14.1657H12.2052C14.2477 14.1657 15.9383 12.6187 16.2167 10.616L18.0434 11.5204C18.3542 11.6744 18.6869 11.7507 19.0183 11.7507C19.428 11.7507 19.8364 11.6338 20.198 11.4035C20.8525 10.9863 21.2437 10.2681 21.2437 9.4813V4.9194C21.2437 4.1326 20.8532 3.4144 20.198 2.9972ZM15.0239 10.035C15.0239 11.6177 13.7596 12.905 12.2052 12.905H4.81248C3.25804 12.905 1.99373 11.6177 1.99373 10.035V4.365C1.99373 2.7823 3.25804 1.495 4.81248 1.495H12.2052C13.7596 1.495 15.0239 2.7823 15.0239 4.365V10.035ZM20.0062 9.4806C20.0062 9.8348 19.8364 10.1463 19.5415 10.3346C19.2459 10.5229 18.8966 10.5418 18.5838 10.3864L16.2607 9.2363V5.1637L18.5838 4.0136C18.8966 3.8575 19.2459 3.8771 19.5415 4.0654C19.8371 4.2537 20.0062 4.5645 20.0062 4.9187V9.4806Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteVideo);
export default __webpack_public_path__ + "static/media/white_video.fe76b26003b725e49efb55b7e523c50c.svg";
export { ForwardRef as ReactComponent };